import {
    Space,
    Alert,
    Spin,
    Divider,
} from 'antd';
import { FC, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
    Delivery,
    Header,
    Information,
    OtherDetails,
    ProofOfDelivery,
    StatusUpdates,
    Timeline,
} from '../../components/BookingDetail';

import { getBooking, getBookingEvents } from '../../api/bookings.api';
import { IBooking, IBookingEvent } from '../../interfaces/booking.interface';

const BookingDetail: FC = () => {
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [loadingEvents, setLoadingEvents] = useState<boolean>(false);
    const [booking, setBooking] = useState<IBooking>({} as IBooking);
    const [timeType, setTimelineType] = useState<boolean>(false);
    const [events, setEvents] = useState<IBookingEvent[]>([]);

    const params = useParams();
    const bookingID = params.id;

    const fetchEvents = () => {
        setLoadingEvents(true);
        getBookingEvents(bookingID as string)
            .then(({ body }: any) => {
                setEvents(body);
            })
            .catch((error: any) => setError(error.message))
            .finally(() => setLoadingEvents(false));
    };

    const fetchBooking = () => {
        setLoading(true);
        getBooking(bookingID as string)
            .then((data) => {
                setBooking(data);
                if (data._id) fetchEvents();
            })
            .catch((error: any) => setError(error.message))
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        if (!bookingID) return;
        fetchBooking();
    }, [bookingID]);

    return (
        <div className="screen">
            <div className="section" style={{ paddingTop: 0 }}>
                {
                    error ? (
                        // TODO: Add a error component
                        <Alert message={error} type="error" showIcon />
                    ) : loading ? (
                        // TODO: Add a loading component
                        <Spin />
                    ) : (
                        <Space direction="vertical" size={24} style={{ width: '100%' }}>
                            <Header {...booking} />
                            <Divider />
                            <Information {...booking} />
                            {
                                timeType ? (
                                    <Space direction="vertical" size={0}>
                                        <StatusUpdates
                                            {...booking}
                                            timelineType={timeType}
                                            handleChangeTimelineType={setTimelineType}
                                        />
                                    </Space>
                                ) : (
                                    <Timeline
                                        booking={booking}
                                        loading={loadingEvents}
                                        events={events}
                                        timelineType={timeType}
                                        handleChangeTimelineType={setTimelineType}
                                    />
                                )
                            }
                            <Delivery {...booking} />

                            <ProofOfDelivery bookingData={booking} />

                            <OtherDetails {...booking} />
                        </Space>
                    )
                }
            </div>
        </div>
    );
};

export { BookingDetail };
